// Dauber HQ — pattern showcase + interactive builder.
// Self-initializing. Activates only on pages that include the data hooks:
//   Showcase:  <div data-pattern-showcase data-src="/assets/data/patterns.json" [data-limit="8"] [data-filters]></div>
//   Builder:   a container with [data-pattern-board], optional [data-pattern-swatches],
//              [data-pattern-code], [data-pattern-clear], [data-pattern-freespace].
// Patterns are the app's built-in snapshot: cells = row-major 25-char "0/1", accent = palette key.

(function () {
  'use strict';

  // Accent key -> hex, mirrors the app's PATTERN_ACCENT_COLORS.
  var ACCENT = {
    amber: '#FFB547', mint: '#6ED6B8', coral: '#FF7A59',
    blue: '#3E6AFF', lilac: '#A78BFA', rose: '#FF5A8A',
    royal: '#3E6AFF', purple: '#A78BFA', pink: '#FF5A8A'
  };
  function hex(k) { return ACCENT[k] || '#6ED6B8'; }

  // Render a 25-char cells string into a .pgrid element (HTML string).
  function gridHTML(cells, accentHex) {
    var h = '';
    for (var i = 0; i < 25; i++) {
      h += '<span class="pgrid__c' + (cells.charAt(i) === '1' ? ' is-on' : '') + '"></span>';
    }
    return '<div class="pgrid" style="--accent:' + accentHex + '">' + h + '</div>';
  }

  // ── Showcase ────────────────────────────────────────────────
  function initShowcase(root) {
    var src = root.getAttribute('data-src') || '/assets/data/patterns.json';
    var limit = parseInt(root.getAttribute('data-limit') || '0', 10);
    var wantFilters = root.hasAttribute('data-filters');

    var filtersEl = wantFilters ? document.createElement('div') : null;
    if (filtersEl) { filtersEl.className = 'pattern-filters'; root.appendChild(filtersEl); }
    var gridEl = document.createElement('div');
    gridEl.className = 'pattern-showcase';
    root.appendChild(gridEl);

    var all = [], active = 'All';
    function paint() {
      var list = active === 'All' ? all : all.filter(function (p) { return p.category === active; });
      if (limit > 0) list = list.slice(0, limit);
      gridEl.innerHTML = list.map(function (p) {
        return '<figure class="pcard">' + gridHTML(p.cells, hex(p.accent)) +
          '<figcaption class="pcard__name">' + p.name + '</figcaption>' +
          '<span class="pcard__cat">' + p.category + '</span></figure>';
      }).join('');
    }

    fetch(src).then(function (r) { return r.json(); }).then(function (data) {
      all = data;
      if (filtersEl) {
        var cats = ['All'].concat(data.map(function (p) { return p.category; })
          .filter(function (v, i, a) { return a.indexOf(v) === i; }).sort());
        filtersEl.innerHTML = cats.map(function (c, i) {
          return '<button type="button" class="pattern-filters__btn' + (i === 0 ? ' is-active' : '') +
            '" data-cat="' + c + '">' + c + '</button>';
        }).join('');
        filtersEl.addEventListener('click', function (e) {
          var b = e.target.closest('[data-cat]'); if (!b) return;
          active = b.getAttribute('data-cat');
          Array.prototype.forEach.call(filtersEl.children, function (x) { x.classList.toggle('is-active', x === b); });
          paint();
        });
      }
      paint();
    }).catch(function () { gridEl.innerHTML = '<p class="pattern-showcase__error">Patterns are taking a minute. Refresh in a moment.</p>'; });
  }

  // ── Builder ─────────────────────────────────────────────────
  function initBuilder(board) {
    var scope = board.closest('[data-pattern-builder-scope]') || document;
    var swatchesEl = scope.querySelector('[data-pattern-swatches]');
    var codeEl = scope.querySelector('[data-pattern-code]');
    var clearEl = scope.querySelector('[data-pattern-clear]');
    var freeEl = scope.querySelector('[data-pattern-freespace]');

    var cells = new Array(25).fill('0');
    var accent = 'mint';
    board.style.setProperty('--accent', hex(accent));

    function code() { return cells.join(''); }
    function sync() {
      Array.prototype.forEach.call(board.children, function (el) {
        el.classList.toggle('is-on', cells[+el.getAttribute('data-i')] === '1');
      });
      if (codeEl) codeEl.textContent = code();
    }
    function build() {
      var h = '';
      for (var i = 0; i < 25; i++) h += '<button type="button" class="pgrid__c' + (cells[i] === '1' ? ' is-on' : '') + '" data-i="' + i + '" aria-label="cell ' + (i + 1) + '"></button>';
      board.innerHTML = h;
      board.addEventListener('click', function (e) {
        var c = e.target.closest('[data-i]'); if (!c) return;
        var i = +c.getAttribute('data-i'); cells[i] = cells[i] === '1' ? '0' : '1'; sync();
      });
      if (codeEl) codeEl.textContent = code();
    }

    if (swatchesEl) {
      var keys = ['mint', 'royal', 'rose', 'amber', 'purple', 'coral'];
      swatchesEl.innerHTML = keys.map(function (k) {
        return '<button type="button" class="pattern-swatch' + (k === accent ? ' is-active' : '') +
          '" data-k="' + k + '" style="--sw:' + hex(k) + '" aria-label="' + k + '"></button>';
      }).join('');
      swatchesEl.addEventListener('click', function (e) {
        var s = e.target.closest('[data-k]'); if (!s) return;
        accent = s.getAttribute('data-k'); board.style.setProperty('--accent', hex(accent));
        Array.prototype.forEach.call(swatchesEl.children, function (x) { x.classList.toggle('is-active', x === s); });
      });
    }
    if (clearEl) clearEl.addEventListener('click', function () { cells = new Array(25).fill('0'); sync(); });
    if (freeEl) freeEl.addEventListener('click', function () { cells[12] = cells[12] === '1' ? '0' : '1'; sync(); });

    // Seed with an X so it reads as alive on load.
    '0000001010001000010100000'.split('').forEach(function (v, i) { cells[i] = v; });
    build();
  }

  function init() {
    document.querySelectorAll('[data-pattern-showcase]').forEach(initShowcase);
    document.querySelectorAll('[data-pattern-board]').forEach(initBuilder);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
